module.exports = __webpack_public_path__ + "static/use-case-6-content-3-b-f6800a85857521bd3eb479d3503849bb.png";